import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PartGroupDto} from "../../../../auto-generated-server-dtos/claim/repairs/part-group-dto";
import {Observable} from "rxjs";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GetAvailablePartsService {

  constructor(private httpClient: HttpClient) { }

  public GetAvailableParts(warrantyId: number): Observable<PartGroupDto[]> {
    return this.httpClient.get<PartGroupDto[]>(`${environment.apiServer}/GetAvailableParts`, {params: {warrantyId: warrantyId}});
  }

}
